module.exports = __webpack_public_path__ + "img/1_1-commerciale-panettiere-1.3613ec4c.png";